// extracted by mini-css-extract-plugin
export default {"banner":"CookieConsentBanner_banner__btbVO","slideUp":"CookieConsentBanner_slideUp__Z2YJd"};